import React from 'react';
import { Modal } from 'react-bootstrap';
import './modal.style.scss';
import { __ModalProps } from './modal.interface';
import Button from '../../slp/button/button.index';

const UCheckModal: React.FC<__ModalProps> = function (props: __ModalProps) {
    return (
        <Modal
            show={props.status}
            className={`ucheck-modal ${props.className ? props.className : ''}`}
            size={props.size ? props.size : 'lg'}
            centered
            onHide={props.onClose}
        >
            <i onClick={props.onClose} className="ufi ufi-x"></i>
            <div style={props.style} className="ucheck-modal-body">
                {props.children}
            </div>
            {props.submit || props.close ? (
                <div className="ucheck-modal-footer">
                    {props.submit && (
                        <Button disabled={props.submitDisabled} onClick={props.onSubmit}>
                            {props.submit}
                        </Button>
                    )}
                    {props.close && (
                        <Button className="cancel-button" onClick={props.onClose}>
                            {props.close}
                        </Button>
                    )}
                </div>
            ) : null}
        </Modal>
    );
};

export default UCheckModal;
